module.exports = __webpack_public_path__ + "static/img/7.accddfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/7.png
// module id = ++6K
// module chunks = 7